import { css } from '@linaria/core';
export const textWrapper = "omponents__ModelTypeIcon__ModelTypeIcon_styles_ts-textWrapper-tnjflv6";
export const iconWrapper = "omponents__ModelTypeIcon__ModelTypeIcon_styles_ts-iconWrapper-i14dgkd9";
export const labelWrapper = "omponents__ModelTypeIcon__ModelTypeIcon_styles_ts-labelWrapper-l1gd0dxg";
export const iconClose = "omponents__ModelTypeIcon__ModelTypeIcon_styles_ts-iconClose-iz8nv3h";

require("./ModelTypeIcon.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ModelTypeIcon.styles.ts");